<router-outlet /> <app-spinner />